/**
 * GSAP, its plugins and the house defaults — imported from here only, so
 * the plugins are registered once.
 *
 * @module lib/gsap
 */

import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { Flip } from 'gsap/Flip';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(CustomEase, DrawSVGPlugin, Flip, ScrollSmoother, ScrollToPlugin, ScrollTrigger, SplitText);

// The house easing: a long, soft landing (the CSS --ease is its twin).
CustomEase.create('hood', '0.16, 1, 0.3, 1');

gsap.defaults({ ease: 'hood', duration: 1 });

export { Flip, ScrollSmoother, ScrollTrigger, SplitText, gsap };
